import type { ComponentSchema } from '../../../../../schema-types'
import { SECTION_STYLE_FIELDS } from './_fields'

/** Sunshine band with a countdown over the most discounted products; hidden after it ends. */
export const schema: ComponentSchema = {
  type: 'flash-sale',
  label: 'Flash sale',
  description: 'A countdown to the end date over a row of the most discounted products. Hidden after it ends.',
  supportedPages: ['home'],
  variants: [{ id: 'v1', label: 'Sunshine band' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'Flash sale on toys' },
    { key: 'endDate', label: 'Ends at (ISO date)', type: 'string', placeholder: '2026-12-31T23:59:59' },
    ...SECTION_STYLE_FIELDS,
  ],
}
